import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";
import SelectDropdown from "../../components-react/SelectDropdown";
import { selectAuth } from "../../auth/auth.selector";
import MultiRowSelectTable from "./MultiRowSelectTable";
import { fetchPTTrainersData } from "../../../redux/reducers/apiSlice";
import { toast } from "react-toastify";
import { changePTTrainer } from "../../../redux/reducers/postApiSlice";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";

const ChangeTrainer = ({ queryParametersForAll, onCloseModal }) => {
  const dispatch = useDispatch();
  const userInfo = useSelector(selectAuth);
  const { allPTTrainersData } = useSelector((state) => state.api);

  const [decryptedText, setDecryptedText] = useState(userInfo?.user || {});
  const [selectedTrainer, setSelectedTrainer] = useState("");
  const initialSelectedRowDetails = {
    selectedRows: [],
    selectedSubsId: [],
    selectedTrainerIds: [],
    selectedGymIds: [],
  };
  const [selectedRowInfo, setSelectedRowInfo] = useState(
    initialSelectedRowDetails
  );
  // const [selectedRows, setSelectedRows] = useState([]);
  const [trainersData, setAllTrainersData] = useState([]);
  const [selectedGym, setSelectedGym] = useState("");

  const getParameterValue = (parameterName, queryString) => {
    const regex = new RegExp(`[?&]${parameterName}=([^&]*)`);
    const match = regex.exec(queryString);
    return match ? decodeURIComponent(match[1]) : null;
  };
  const selectedGymValue = getParameterValue("gym_id", queryParametersForAll);

  const onClickChangeTrainer = () => {
    if (selectedRowInfo.selectedRows?.length === 0) {
      toast.error("Please Select Member To Change Trainer");
    } else if (!selectedTrainer) {
      toast.error("Please Select Trainer!");
    } else if (!selectedGym && !selectedGymValue) {
      toast.error("Please Select Gym!");
    } else {
      const userData = {
        gym_id: selectedGym?.value ? selectedGym.value : selectedGymValue,
        trainer_id: selectedTrainer?.value,
        members: selectedRowInfo.selectedRows,
        status: "active",
        subscription_id: selectedRowInfo.selectedSubsId,
        is_pt: true,
        mapped_from: "web",
      };

      onChangeTrainer(userData, decryptedText?.token);
    }
  };

  const onChangeTrainer = async (userData, TOKEN) => {
    try {
      const actionResult = dispatch(changePTTrainer({ userData, TOKEN }));
      const result = await actionResult;

      // console.log("result=> ", result);

      if (result?.payload?.status) {
        setSelectedRowInfo(initialSelectedRowDetails);
        setSelectedTrainer("");
        toast.success(result.payload?.message || "Successfull!");
        onCloseModal();
      } else {
        const errorMessage = result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.log("onClickChangeTrainer ERROR => ", error);
    }
  };

  const onClickModalClose = () => {
    onCloseModal();
    setSelectedRowInfo(initialSelectedRowDetails);
  };

  useEffect(() => {
    if (selectedGymValue) {
      dispatch(
        fetchPTTrainersData({
          gymId: selectedGym?.value ? selectedGym.value : selectedGymValue,
          token: decryptedText?.token,
        })
      );
    } else {
      dispatch(
        fetchPTTrainersData({
          gymId: "",
          token: decryptedText?.token,
        })
      );
    }
  }, [selectedGymValue, selectedGym]);

  useEffect(() => {
    if (allPTTrainersData?.status && allPTTrainersData?.data?.length > 0) {
      const trainers = allPTTrainersData.data?.map((item) => ({
        value: item.user_id,
        label: item.name,
      }));
      setAllTrainersData(trainers);
    } else {
      setAllTrainersData([]);
    }
  }, [allPTTrainersData]);

  useEffect(() => {
    if (userInfo?.isAuthenticated && userInfo?.user) {
      setDecryptedText(userInfo.user);
    }
  }, [userInfo]);

  return (
    <>
      {/* <div className="createNewCTOModalContainer"> */}
      <ModalHeadAndClose title="Select member" onClose={onClickModalClose} />
      <>
        <div className="formContainer changeTrainerContainer">
          <div className="formButtons mt30">
            <div className="filter">
              <div className="commonWrapper changeTrainerFilterUpdate">
                <SelectDropdown
                  options={trainersData}
                  selectedOption={selectedTrainer}
                  setSelectedOption={(selectedValue) =>
                    setSelectedTrainer(selectedValue)
                  }
                  name="Trainer From The List"
                />
              </div>
            </div>
            <Button
              className="saveBtn"
              variant="danger"
              style={{ fontSize: "15px", height: "60px" }}
              onClick={onClickChangeTrainer}
            >
              Update Trainer
            </Button>
          </div>

          <div className="allPtMembersTableContainer">
            {/* <PaginatedTable columnsValues={allPtMembers} dataValues={[]} /> */}
            <MultiRowSelectTable
              // selectedRows={selectedRows}
              // setSelectedRows={setSelectedRows}
              // setSelectedSubsId={setSelectedSubsId}
              initialSelectedRowDetails={initialSelectedRowDetails}
              selectedRowInfo={selectedRowInfo}
              setSelectedRowInfo={setSelectedRowInfo}
              setSelectedGym={setSelectedGym}
              queryParametersForAll={queryParametersForAll}
            />
          </div>
        </div>
      </>{" "}
      {/* </div> */}
    </>
  );
};

export default ChangeTrainer;
